import React from 'react';
import PropTypes from 'prop-types';
import withTextInput from './withTextInput';
import { InputTypes } from './InputTypes';

const TextInputComponent = withTextInput('input');

const TextInput = props => <TextInputComponent {...props} />;

TextInput.defaultProps = {
  autoComplete: 'off',
  className: '',
  label: '',
  placeholder: '',
  type: 'text',
  value: undefined,
};

TextInput.propTypes = {
  autoComplete: PropTypes.string,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  type: PropTypes.oneOf(InputTypes),
  value: PropTypes.string,
};

export default TextInput;



// WEBPACK FOOTER //
// ./src-react/DesignSystem/TextInputs/TextInput.jsx